import { objectToGetParams, type QueryProps } from "@ihr-radioedit/inferno-core";
import { isWindowDefined } from "../utilities/window";

export function createAuthorizeRequestHelpers({
  protocol,
  hostname,
  hostnameUri,
  baseUri = "/api/v4",
  accountHost,
  path,
  oauthClientId,
  prHostname,
  prHostnameUri,
  prNumber,
}: {
  protocol: string;
  hostname: string;
  hostnameUri: string;
  baseUri: string;
  accountHost: string;
  path: string;
  oauthClientId: string;
  prHostname?: string;
  prHostnameUri?: string;
  prNumber?: number | boolean;
}) {
  function _insertPreprod(hostName: string) {
    return hostName.replace(/(\w+-\w{2})(\.inferno\.iheart\.com)/, "$1--preprod$2");
  }

  function _getBase(hostName: string) {
    let updatedProtocol = protocol;
    if (!updatedProtocol.endsWith(":")) {
      updatedProtocol += ":";
    }

    return `${updatedProtocol}//${hostName}`;
  }

  function _getRedirect(type: "url" | "uri" = "url") {
    const prHosts = type === "url" ? prHostname : prHostnameUri;

    const localStagingProdHosts = type === "url" ? hostname : hostnameUri;

    return prHosts || localStagingProdHosts!;
  }

  return {
    getAccountUrlWithRedirects: (currPath: string, redirectUriPath: string, searchParams: string | QueryProps) => {
      const accountUrl = new URL(currPath, accountHost);

      const redirectUri = new URL(baseUri + redirectUriPath, _getBase(_getRedirect("uri")));
      const redirectUrl = new URL(path, _getBase(_getRedirect()));

      // HACK: This is a workaround to get preprod and oauth working together..
      // For some reason, once the req gets into RE, --preprod thats part of the url- gets dropped from the hostname,
      // we should add and update the vcl and forward the --preprod flag to RE, so we can add this logic from inferno via server put it in the store
      // This also affects the Login token flow which will NOT work in preprod, so only test in staging -- at some we will need to forward the preprod header from VCL in the future
      if (isWindowDefined()) {
        if (location.hostname.includes("--preprod")) {
          redirectUri.hostname = _insertPreprod(redirectUri.hostname);
          redirectUrl.hostname = _insertPreprod(redirectUrl.hostname);
        }
      }

      const params = typeof searchParams !== "string" ? objectToGetParams(searchParams) : searchParams;
      const currentSearchParams = new URLSearchParams(params);
      currentSearchParams.forEach((value, key) => {
        if (key.toLowerCase() === "logintoken" || key.toLowerCase() === "loginToken") {
          return;
        }
        redirectUrl.searchParams.append(key, value);
      });

      accountUrl.searchParams.set("client_id", prNumber ? prNumber.toString() : oauthClientId);
      accountUrl.searchParams.set("redirect_uri", redirectUri.toString());
      accountUrl.searchParams.set("redirectUrl", redirectUrl.toString());

      return accountUrl;
    },

    // HACK: This is a workaround to get preprod and oauth working together.. see note above
    getAuthUrl: (targetPath: string) => {
      const infernoUrl = new URL(baseUri + targetPath, _getBase(_getRedirect()));

      if (isWindowDefined()) {
        if (location.hostname.includes("--preprod")) {
          infernoUrl.hostname = _insertPreprod(infernoUrl.hostname);
        }
      }

      return infernoUrl;
    },
  };
}
